<template>
  <div>
    <site-header/>
    <favourite-list/>
    <site-footer/>
  </div>
</template>

<script>
  import SiteHeader from '@/components/SiteHeader'
  import SiteFooter from '@/components/SiteFooter'
  import FavouriteList from '@/components/FavouriteList'

  export default {
    name: 'FavouritesPage',
    components: {
      FavouriteList,
      SiteFooter,
      SiteHeader
    }
  };
</script>
